import script from "./GlobalPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalPolicy.vue?vue&type=script&setup=true&lang=js"

import "./GlobalPolicy.vue?vue&type=style&index=0&id=1e204ab8&lang=css"

const __exports__ = script;

export default __exports__